import { heroCovers, siteName } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden pt-24 md:pt-28">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-accent-200/30 blur-3xl" />

      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-4 pt-6 md:px-6 md:pt-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-12">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-300/60 bg-primary-100/70 px-4 py-1.5 text-xs font-medium tracking-[0.18em] text-primary-900">
              <i className="ri-bookmark-3-line" />
              专题合集 · 完整版放映
            </span>

            <h1 className="mt-5 font-heading text-5xl font-black leading-[1.05] tracking-tight text-foreground-950 md:text-6xl lg:text-[68px]">
              {siteName}
            </h1>

            <p className="mt-5 max-w-xl text-base leading-8 text-foreground-700 md:text-lg">
              把观看入口、未删减高清资源与百度云分享，整理在同一条路径上——
              先看画面，再决定从哪一段进入这段出走。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#resource"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                <i className="ri-play-fill text-lg" />
                立即播放在线观看
              </a>
              <a
                href="#resource"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:bg-accent-50"
              >
                <i className="ri-cloud-line text-lg" />
                获取百度云分享
              </a>
            </div>

            <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-background-200/70 pt-6">
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-950">完整版</p>
                <p className="mt-1 text-xs tracking-wide text-foreground-500">未删减全片时长</p>
              </div>
              <div className="h-9 w-px bg-background-200" />
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-950">1080P</p>
                <p className="mt-1 text-xs tracking-wide text-foreground-500">高清画质资源</p>
              </div>
              <div className="h-9 w-px bg-background-200" />
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-950">百度云</p>
                <p className="mt-1 text-xs tracking-wide text-foreground-500">网盘可离线保存</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4">
            {heroCovers.map((cover, idx) => (
              <a
                key={cover.id}
                href="#gallery"
                className={[
                  "group relative block animate-fade-up overflow-hidden rounded-xl border border-background-200/70 bg-background-100",
                  idx === 1 ? "sm:-mt-6" : "",
                  idx === 0 ? "col-span-2 sm:col-span-1" : "",
                ].join(" ")}
                style={{ animationDelay: `${idx * 120}ms` }}
              >
                <div className="relative aspect-[7/10] w-full">
                  <img
                    src={cover.image}
                    alt={`${siteName} ${cover.title} 画面剧照`}
                    title={`${siteName} ${cover.title} 高清剧照`}
                    className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-4">
                    <span className="text-[10px] font-medium tracking-[0.25em] text-primary-200">
                      {cover.tag}
                    </span>
                    <p className="mt-1 font-heading text-lg font-bold text-background-50">
                      {cover.title}
                    </p>
                    <p className="mt-0.5 text-xs text-background-200/90">{cover.caption}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}